import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Headers from '../components/Header'; // Corrected import path
import Footer from '../components/home/Footer'; // Corrected import path
// import Header from '../../components/Header'; // Assuming Header is part of a general Layout
// You might need to import CSS or styling solution here if not handled globally
// import './AffiliateProgramPage.css'; // Example: if you create a specific CSS file

const AffiliateProgramPage = () => {
  // State for hover effects on the three cards
  const [hoverState, setHoverState] = useState({ card1: false, card2: false, card3: false });

  const cardBaseStyle = {
    padding: '20px',
    backgroundColor: 'rgba(0,0,0,0.2)',
    borderRadius: '10px',
    height: '100%',
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out' // Smooth transition
  };

  const cardHoverStyle = {
    transform: 'scale(1.03)', // Slight scale up
    boxShadow: '0px 8px 20px rgba(0, 255, 0, 0.2)' // Subtle green glow, matches CTA button
  };

  return (
    <div className="homeBg"> {/* Use homeBg class for background */}
      <Headers /> {/* Add Headers (navbar) */}
      
      <div style={{ paddingTop: '80px', paddingBottom: '80px'}}> {/* Increased bottom padding for more space before footer */}
        <div className="container text-center"> 
          <h2 className="mb-3" style={{ color: 'white', fontWeight: 'bold' }}>Join Our Affiliate Program!</h2>
          <p className="lead mb-5" style={{ color: '#e0e0e0', fontSize: '1.2rem' }}>
            Partner with TherapywithAI and earn by sharing our revolutionary mental wellness platform.
          </p>
          
          <div className="row justify-content-center">
            <div className="col-md-8">

              <div className="mb-5">
                <h3 className="mb-4" style={{ color: 'white', fontWeight: '600' }}>Why Partner With Us?</h3>
                <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)', padding: '30px', borderRadius: '15px' }}>
                  <h3 className="mb-3" style={{ color: '#00FF00', fontWeight: 'bold', fontSize: '2.5rem' }}> {/* Bright color for commission */}
                    Earn a Massive 40% Commission!
                  </h3>
                  <p style={{ color: 'white', fontSize: '1.1rem' }}>
                    Receive a generous 40% commission for every new subscriber you refer. The more you share, the more you earn.
                  </p>
                  <ul className="list-unstyled mt-3" style={{ color: '#e0e0e0', fontSize: '1.1rem'}}>
                    <li className="mb-2"><i className="fas fa-check-circle mr-2" style={{color: '#0ebfcca6'}}></i> Promote a service that genuinely helps people</li>
                    <li className="mb-2"><i className="fas fa-check-circle mr-2" style={{color: '#0ebfcca6'}}></i> Access to easy-to-use tracking</li>
                    <li><i className="fas fa-check-circle mr-2" style={{color: '#0ebfcca6'}}></i> Reliable and timely payouts</li>
                  </ul>
                </div>
              </div>

              <h3 className="mb-4" style={{ color: 'white', fontWeight: '600' }}>Getting Started is Easy</h3>
              <div className="row text-left">
                <div className="col-md-4 mb-3">
                  <div 
                    style={ hoverState.card1 ? {...cardBaseStyle, ...cardHoverStyle} : cardBaseStyle }
                    onMouseEnter={() => setHoverState(prev => ({...prev, card1: true}))}
                    onMouseLeave={() => setHoverState(prev => ({...prev, card1: false}))}
                  >
                    <h4 style={{ color: '#0ebfcca6' }}>1. Sign Up</h4>
                    <p style={{ color: '#e0e0e0' }}>Quick and easy registration on our dedicated affiliate portal</p>
                  </div>
                </div>
                <div className="col-md-4 mb-3">
                  <div 
                    style={ hoverState.card2 ? {...cardBaseStyle, ...cardHoverStyle} : cardBaseStyle }
                    onMouseEnter={() => setHoverState(prev => ({...prev, card2: true}))}
                    onMouseLeave={() => setHoverState(prev => ({...prev, card2: false}))}
                  >
                    <h4 style={{ color: '#0ebfcca6' }}>2. Share Your Link</h4>
                    <p style={{ color: '#e0e0e0' }}>Grab your unique referral link and share it with your audience</p>
                  </div>
                </div>
                <div className="col-md-4 mb-3">
                  <div 
                    style={ hoverState.card3 ? {...cardBaseStyle, ...cardHoverStyle} : cardBaseStyle }
                    onMouseEnter={() => setHoverState(prev => ({...prev, card3: true}))}
                    onMouseLeave={() => setHoverState(prev => ({...prev, card3: false}))}
                  >
                    <h4 style={{ color: '#0ebfcca6' }}>3. Earn Big!</h4>
                    <p style={{ color: '#e0e0e0' }}>Get 40% commission for every new subscriber you bring in!</p>
                  </div>
                </div>
              </div>

              <div className="mt-5 pt-3">
                <a 
                  href="https://therapywithai.goaffpro.com/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="btn btn-primary btn-lg"
                  style={{
                    backgroundColor: '#00FF00', // Changed to match commission color
                    borderColor: '#00FF00',
                    color: '#005000', // Darker text for contrast on bright green
                    padding: '18px 35px',
                    fontSize: '1.3rem',
                    borderRadius: '30px',
                    textTransform: 'uppercase',
                    fontWeight: 'bold',
                    boxShadow: '0px 5px 20px rgba(0, 255, 0, 0.3)'
                  }}
                >
                  Start Earning 40% Today!
                </a>
                <p className="mt-3" style={{ color: '#e0e0e0' }}>
                  It's free to join and takes just a few minutes
                </p>
              </div>

              {/* Optional: Keep a direct link if desired, or remove if button is sufficient */}
              {/* <p className="mt-4">
                <Link 
                  to="https://therapywithai.goaffpro.com/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  style={{ color: '#add8e6' }}
                >
                  Or click here to visit the portal: https://therapywithai.goaffpro.com/
                </Link>
              </p> */}
            </div>
          </div>
        </div>
      </div>
      
      <Footer /> {/* Add Footer */}
    </div>
  );
};

export default AffiliateProgramPage; 